const minutes = (seconds) => (seconds ? `${Math.round(seconds / 60)} min` : "Not reported");

export default function CameraStatusCard({ status }) {
  const config = status?.config;
  const ackApplied = config?.acknowledged && config?.ack_status === "ok";
  const applied = ackApplied || config?.reported_match;
  const rejected = config?.acknowledged && config?.ack_status && config.ack_status !== "ok";
  const state = !config
    ? "No schedule sent"
    : applied
      ? "Applied"
      : rejected
        ? `Device rejected: ${config.ack_status}`
        : "Waiting for sleeping device";
  const staleAfterMs = Math.max(
    (status?.configured_interval_seconds || 3600) * 1500,
    5 * 60 * 1000
  );
  const statusIsStale =
    status?.last_status_at &&
    Date.now() - new Date(status.last_status_at).getTime() > staleAfterMs;

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-slate-500">RTC schedule</p>
          <h2 className="mt-1 text-lg font-bold text-slate-900">{state}</h2>
        </div>
        <span className={`rounded-full px-2.5 py-1 text-xs font-bold ${
          applied ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"
        }`}>
          {applied ? "In sync" : "Pending"}
        </span>
      </div>
      <dl className="mt-4 grid grid-cols-2 gap-3 text-sm lg:grid-cols-4">
        <div><dt className="text-slate-500">Configured</dt><dd className="font-semibold">{minutes(status?.configured_interval_seconds)}</dd></div>
        <div><dt className="text-slate-500">Device reported</dt><dd className="font-semibold">{minutes(status?.reported_interval_seconds)}</dd></div>
        <div><dt className="text-slate-500">Requested run</dt><dd className="font-mono text-xs">{status?.run || "—"}</dd></div>
        <div><dt className="text-slate-500">Reported run</dt><dd className="font-mono text-xs">{status?.reported_run || "—"}</dd></div>
      </dl>
      <div className="mt-3 border-t border-slate-100 pt-3 text-xs text-slate-500">
        <p>Request: <span className="font-mono">{config?.request_id || "—"}</span></p>
        {config?.sent_at && (
          <p className="mt-1">Published request: {new Date(config.sent_at).toLocaleString()}</p>
        )}
        {config?.ack_received_at && (
          <p className="mt-1">
            Device ACK received: {new Date(config.ack_received_at).toLocaleString()}
          </p>
        )}
        <p className="mt-1">
          Last device status: {status?.last_status_at ? new Date(status.last_status_at).toLocaleString() : "never"}
          {statusIsStale ? " · stale beyond the expected RTC interval" : ""}
          {config?.ack_reason ? ` · ${config.ack_reason}` : ""}
        </p>
      </div>
    </section>
  );
}
